import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea"];

  connect() {
    this.boundHandleMouseUp = this.handleMouseUp.bind(this);
    this.boundHighlight = this.highlightPlaceholder.bind(this);
    this.boundHandleTab = this.handleTabKey.bind(this);

    this.textarea.addEventListener("mouseup", this.boundHandleMouseUp);
    this.textarea.addEventListener("change", this.boundHighlight);
    this.textarea.addEventListener("keydown", this.boundHandleTab);

    if (this.hasPlaceholder) {
      if (document.activeElement === document.body || document.activeElement === null) {
        this.textarea.focus();
        this.highlightPlaceholder();
      }
    }
  }

  disconnect() {
    this.textarea.removeEventListener("mouseup", this.boundHandleMouseUp);
    this.textarea.removeEventListener("change", this.boundHighlight);
    this.textarea.removeEventListener("keydown", this.boundHandleTab);
  }

  extendSelection() {
    const textarea = this.textarea;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;

    if (
      start != end &&
      start >= 2 &&
      end <= text.length - 2 &&
      text.substring(start - 2, start) === "[[" &&
      text.substring(end, end + 2) === "]]"
    ) {
      textarea.setSelectionRange(start - 2, end + 2);
    }
  }

  handleMouseUp() {
    // Only highlight placeholder on a simple click (no drag selection)
    if (this.textarea.selectionStart === this.textarea.selectionEnd && this.hasPlaceholder) {
      this.highlightPlaceholder();
    }
  }

  highlightPlaceholder() {
    const textarea = this.textarea;

    setTimeout(() => {
      const text = textarea.value;
      const match = text.match(/\[\[(.*?)\]\]/);

      if (match) {
        const startPos = match.index;
        const endPos = startPos + match[0].length;
        textarea.setSelectionRange(startPos, endPos);
      }
    }, 10);
  }

  handleTabKey(event) {
    if (event.key === "Tab" && this.hasPlaceholder) {
      event.preventDefault();
      this.highlightNextPlaceholder();
    }
  }

  highlightNextPlaceholder() {
    const textarea = this.textarea;
    const text = textarea.value;
    const cursorPos = textarea.selectionEnd;
    const regex = /\[\[(.*?)\]\]/g;

    // Find the next placeholder after the cursor
    let match;
    while ((match = regex.exec(text)) !== null) {
      if (match.index >= cursorPos) {
        textarea.setSelectionRange(match.index, match.index + match[0].length);
        return;
      }
    }

    // Wrap around to the first placeholder
    const first = text.match(/\[\[(.*?)\]\]/);
    if (first) {
      textarea.setSelectionRange(first.index, first.index + first[0].length);
    }
  }

  get textarea() {
    return this.hasTextareaTarget ? this.textareaTarget : this.element;
  }

  get hasPlaceholder() {
    const placeholderText = this.textarea.value;
    return placeholderText.includes("[[") && placeholderText.includes("]]");
  }
}
